import { get } from './httpClient';

/**
 * Lugares de referencia del pipeline (`reference_places`).
 * Catálogo: `GET /getreferenceplacekinds` (público).
 * Pines: PMTiles firmados en /app; `GET /getreferenceplaces` solo share anónimo.
 */

/**
 * Catálogo del switcher (kinds semillados aunque todavía no haya filas).
 *
 * @param {object} [options]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<object>} Envelope `{ data.categories, _httpOk, _httpStatus }`.
 */
export const getReferencePlaceKinds = ({ signal } = {}) =>
  get('/getreferenceplacekinds', { auth: false, signal });

/**
 * Pines en una caja. `bbox` es `minLon,minLat,maxLon,maxLat` (máx. 2° por lado).
 *
 * @param {object} query
 * @param {string} query.bbox
 * @param {string} [query.kinds]
 * @param {string} [query.subtypes]
 * @param {string} [query.categories]
 * @param {number} [query.limit]
 * @param {object} [options]
 * @param {AbortSignal} [options.signal]
 * @returns {Promise<object>} Envelope `{ data.places, data.returned, data.limit, _httpOk }`.
 */
export const getReferencePlaces = ({
  bbox,
  kinds,
  subtypes,
  categories,
  limit,
} = {}, { signal } = {}) =>
  get('/getreferenceplaces', {
    auth: false,
    signal,
    params: { bbox, kinds, subtypes, categories, limit },
  });
